var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-btn',{staticClass:"base-inverted",attrs:{"fab":"","x-small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon.name || _vm.icon))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }